import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CustomI18nProvider } from "./contexts/I18nProvider";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import NotFound from "./pages/NotFound";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import OtpVerification from "./pages/OtpVerification";
import AddPaymentMethod from "./pages/AddPaymentMethod";
import PricingPage from "./pages/Pricing/Pricing";
import PaymentCompleted from "./pages/PaymentCompleted";
import { useLoggedIn } from "./hooks/use-logged-in";
import Logout from "./pages/Logout";
import Profile from "./pages/Profile";
import ProfileNew from "./pages/Profile/index";
import ForgotPasswordPage from "./pages/ForgotPassword";
import UpdatePasswordPage from "./pages/UpdatePassword";
import GetStarted from "./pages/GetStarted";
import Landing from "./pages/Landing";
import Contact from "./pages/Contact";
import {
  PolyglotThemeChooser,
  PolyglotLegacy,
  PolyglotNdop,
} from "./pages/Polyglot/variants";
import Help from "./pages/Help";

function App() {
  const { isLoggedIn } = useLoggedIn();
  return (
    <CustomI18nProvider>
      <LanguageProvider defaultLanguage="en">
        <ThemeProvider>
          <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/polyglot" element={<PolyglotLegacy />} />
          <Route path="/polyglot-themes" element={<PolyglotThemeChooser />} />
          <Route path="/polyglot-legacy" element={<PolyglotLegacy />} />
          <Route path="/polyglot-ndop" element={<PolyglotNdop />} />
          {isLoggedIn ? (
            <>
              <Route path="/pricing" element={<PricingPage />} />
              <Route
                path="/payment-methods/add"
                element={<AddPaymentMethod />}
              />
              <Route path="/completion" element={<PaymentCompleted />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/profile-1" element={<ProfileNew />} />
            </>
          ) : (
            <>
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/update-password" element={<UpdatePasswordPage />} />
              <Route
                path="/sign-up/otp-verification"
                element={<OtpVerification />}
              />
            </>
          )}
          {/* Logout route - available for all users */}
          <Route path="/logout" element={<Logout />} />
          {/* Profile routes - available for development testing */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile-1" element={<ProfileNew />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/help" element={<Help />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
          </Router>
        </ThemeProvider>
      </LanguageProvider>
    </CustomI18nProvider>
  );
}

export default App;
